export default __webpack_public_path__ + "static/media/login-background@3x.ff9f99d0.jpg";